'use client'

import { z } from 'zod'
import {
  searchQuerySchema,
  searchPageSchema,
  searchPath,
  validateSearchPage,
  SearchContractError,
} from '@/features/veluvit/schemas/search.schema'
import type {
  SearchQuery,
  SearchPage,
} from '@/features/veluvit/schemas/search.schema'

import { ApiError, api } from '@/features/veluvit/services/api'

/** 전체 검색은 기존 계약을 사용한다. 분류 검색은 서버가 적용한 kind를 확인해야 표시한다. */
export async function searchWorks(
  query: SearchQuery,
  offset = 0,
  signal?: AbortSignal
): Promise<SearchPage> {
  const checked = searchQuerySchema.parse(query)
  z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER).parse(offset)
  if (!checked.q)
    throw new ApiError('검색어를 입력해 주세요.', 400, 'SEARCH_QUERY_REQUIRED')

  let path: string
  try {
    path = searchPath(checked, offset)
  } catch (error) {
    if (error instanceof SearchContractError)
      throw new ApiError(error.message, 400, error.code)
    throw error
  }
  const raw = await api<unknown>(path, undefined, 'GET', signal)
  const parsed = searchPageSchema.safeParse(raw)
  if (!parsed.success)
    throw new ApiError(
      '검색 결과를 확인하지 못했어요. 다시 시도해 주세요.',
      502,
      'INVALID_SEARCH_RESPONSE'
    )

  try {
    return validateSearchPage(parsed.data, checked, offset)
  } catch (error) {
    if (error instanceof SearchContractError)
      throw new ApiError(
        error.message,
        error.code === 'SEARCH_KIND_UNSUPPORTED' ? 501 : 502,
        error.code
      )
    throw error
  }
}
